// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AvailableConversationContext",
    "RemovedConversationContext"
  ]);
}

function unwrap_fragment_AvailableConversationContext_context(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "BuyerNeedV5",
    "ForSalePropertyV5",
    "MessageBroadcast",
    "RentalNeedV5",
    "RentalPropertyV5"
  ]);
}

let fragmentConverter = {"__root":{"RemovedConversationContext_agent":{"f":""},"AvailableConversationContext_context_RentalPropertyV5":{"f":""},"AvailableConversationContext_context_RentalNeedV5":{"f":""},"AvailableConversationContext_context_MessageBroadcast":{"f":""},"AvailableConversationContext_context_ForSalePropertyV5":{"f":""},"AvailableConversationContext_context_BuyerNeedV5":{"f":""},"AvailableConversationContext_context":{"u":"fragment_AvailableConversationContext_context"},"":{"u":"fragment"}}};

let fragmentConverterMap = {
  fragment_AvailableConversationContext_context: unwrap_fragment_AvailableConversationContext_context,
  fragment: unwrap_fragment
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function conversationContextTypeV5_decode($$enum) {
  if ($$enum === "BROADCAST_MESSAGE" || $$enum === "RENTAL_PROPERTY" || $$enum === "BUYER_NEED" || $$enum === "RENTAL_NEED" || $$enum === "FOR_SALE_PROPERTY") {
    return $$enum;
  }
}

let conversationContextTypeV5_fromString = conversationContextTypeV5_decode;

let Utils = {
  conversationContextTypeV5_decode: conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: conversationContextTypeV5_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageSelectedConversationContext_conversation",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entityType",
            "storageKey": null
          },
          "action": "NONE"
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "Agent",
            "kind": "LinkedField",
            "name": "agent",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConversationPageSelectedConversationContextRemovedContextCard_agent"
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "type": "RemovedConversationContext",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "context",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ConversationPageSelectedConversationContext_buyerNeed"
                }
              ],
              "type": "BuyerNeedV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ConversationPageSelectedConversationContext_forSaleProperty"
                }
              ],
              "type": "ForSalePropertyV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ConversationPageSelectedConversationContext_broadcast"
                }
              ],
              "type": "MessageBroadcast",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ConversationPageSelectedConversationContext_rentalNeed"
                }
              ],
              "type": "RentalNeedV5",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ConversationPageSelectedConversationContext_rentalProperty"
                }
              ],
              "type": "RentalPropertyV5",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AvailableConversationContext",
      "abstractKey": null
    }
  ],
  "type": "ContextForConversation",
  "abstractKey": "__isContextForConversation"
};
})());

let wrap_fragment = RescriptRelay_Internal.wrapUnion;

let wrap_fragment_AvailableConversationContext_context = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment = unwrap_fragment;
exports.wrap_fragment = wrap_fragment;
exports.unwrap_fragment_AvailableConversationContext_context = unwrap_fragment_AvailableConversationContext_context;
exports.wrap_fragment_AvailableConversationContext_context = wrap_fragment_AvailableConversationContext_context;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
